import React from "react";

export function WorkflowRow({ workflow, paramCount, canRun, onRun, onEdit, onClone, onDelete }) {
  const { id, name, summary, owning_manager_name, is_mine } = workflow;
  const paramLabel =
    paramCount === 0 ? "No parameters" :
    paramCount === 1 ? "1 parameter"   :
    `${paramCount} parameters`;
  // Self-owned rows skip the "Shared by" line and show a small "Your workflow"
  // affordance so managers can tell their own rows apart from shared ones.
  const ownershipLabel = is_mine
    ? " · Your workflow"
    : (owning_manager_name ? ` · Shared by ${owning_manager_name}` : "");

  return (
    <div className="copilot-workflow-row" data-workflow-id={id}>
      <div className="copilot-workflow-row-info">
        <div className="copilot-workflow-row-name">{name}</div>
        {summary && <div className="copilot-workflow-row-summary">{summary}</div>}
        <div className="copilot-workflow-row-meta">
          {paramLabel}
          {ownershipLabel}
        </div>
      </div>
      <div className="copilot-workflow-row-actions">
        {is_mine && onEdit && (
          <button
            type="button"
            className="copilot-modal-btn copilot-modal-btn--ghost"
            onClick={(e) => { e.stopPropagation(); onEdit(id); }}
          >
            Edit
          </button>
        )}
        {!is_mine && (
          <button
            type="button"
            className="copilot-modal-btn copilot-modal-btn--ghost"
            disabled
            title="This workflow was shared by someone else. Clone it first to make your own editable copy."
          >
            Edit
          </button>
        )}
        {!is_mine && onClone && (
          <button
            type="button"
            className="copilot-modal-btn copilot-modal-btn--ghost"
            onClick={(e) => { e.stopPropagation(); onClone(id); }}
          >
            Clone
          </button>
        )}
        {is_mine && onDelete && (
          <button
            type="button"
            className="copilot-modal-btn copilot-modal-btn--ghost copilot-workflow-row-delete"
            aria-label={`Delete ${name}`}
            title="Delete workflow"
            onClick={(e) => { e.stopPropagation(); onDelete(id); }}
          >
            Delete
          </button>
        )}
        <button
          type="button"
          className="copilot-modal-btn copilot-modal-btn--primary"
          disabled={!canRun}
          onClick={(e) => { e.stopPropagation(); onRun(id); }}
        >
          Run
        </button>
      </div>
    </div>
  );
}
